/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { useTheme } from 'styled-components';
import Icon from '../Icon';
import { tokens, orange, inkA } from '../tokens';

// 38x36 ghost action button. Glyph goes orange on hover; accent = orange,
// danger = red (until hovered).
const ActionIcon = ({ icon, title, onClick, danger, accent }) => {
  const theme = useTheme();
  const t = tokens(theme);
  const [h, setH] = useState(false);
  const bg = accent
    ? orange(0.12)
    : h
    ? danger
      ? 'rgba(214,58,36,0.12)'
      : inkA(theme, 0.06)
    : 'transparent';
  const col = accent || h ? t.primary : danger ? '#D63A24' : inkA(theme, 0.6);
  return (
    <button
      title={title}
      onClick={onClick}
      onMouseEnter={() => setH(true)}
      onMouseLeave={() => setH(false)}
      style={{
        width: 38,
        height: 36,
        flexShrink: 0,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 11,
        background: bg,
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        transition: 'background 120ms ease',
      }}
    >
      <Icon name={icon} size={18} color={col} strokeWidth={2.25} />
    </button>
  );
};

export default ActionIcon;
